"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStockStatus = exports.ProductionStatus = void 0;
const react_1 = require("react");
const useTranslate_1 = require("./useTranslate");
const Types_1 = require("Types");
const AddToCart_1 = require("../Components/UI/AddToCart/AddToCart");
const useUserData_1 = __importDefault(require("@/Hooks/useUserData"));
var ProductionStatus;
(function (ProductionStatus) {
    ProductionStatus[ProductionStatus["ACTIVE"] = 0] = "ACTIVE";
    ProductionStatus[ProductionStatus["NO_LONGER_IN_PROD"] = 1] = "NO_LONGER_IN_PROD";
    ProductionStatus[ProductionStatus["AVAILABLE_LATER"] = 2] = "AVAILABLE_LATER";
    ProductionStatus[ProductionStatus["CANCELLED_ON_DEPLETION"] = 3] = "CANCELLED_ON_DEPLETION";
})(ProductionStatus = exports.ProductionStatus || (exports.ProductionStatus = {}));
const useStockStatus = (stocks, productionStatusCode) => {
    const { t, isReady } = (0, useTranslate_1.useTranslate)();
    const userData = (0, useUserData_1.default)();
    const getStockStatus = (productionStatusCode, userContinentKey, amountInStock, locationId) => {
        if (productionStatusCode !== ProductionStatus.ACTIVE && productionStatusCode !== ProductionStatus.CANCELLED_ON_DEPLETION) {
            if (productionStatusCode === ProductionStatus.NO_LONGER_IN_PROD) {
                const message = userContinentKey === Types_1.EContinentKeys.Canada
                    ? t('/haldex/add_to_cart/stock_status/no_longer_in_prod_can')
                    : userContinentKey === Types_1.EContinentKeys.NorthAmerica
                        ? t('/haldex/add_to_cart/stock_status/no_longer_in_prod_usa')
                        : t('/haldex/add_to_cart/stock_status/no_longer_in_prod');
                return { message, colorStatus: AddToCart_1.ColorStatus.Red };
            }
            else {
                const message = userContinentKey === Types_1.EContinentKeys.Canada
                    ? t('/haldex/add_to_cart/stock_status/available_later_can')
                    : userContinentKey === Types_1.EContinentKeys.NorthAmerica
                        ? t('/haldex/add_to_cart/stock_status/available_later_usa')
                        : t('/haldex/add_to_cart/stock_status/available_later');
                return { message, colorStatus: AddToCart_1.ColorStatus.Red };
            }
        }
        else {
            if (userContinentKey === Types_1.EContinentKeys.Europe) {
                return amountInStock
                    ? {
                        message: `${amountInStock} ${t('/haldex/add_to_cart/stock_status/in_stock')}`,
                        colorStatus: AddToCart_1.ColorStatus.Green
                    }
                    : { message: t('/haldex/add_to_cart/stock_status/backorder'), colorStatus: AddToCart_1.ColorStatus.Yellow };
            }
            else if (userContinentKey && (userContinentKey === Types_1.EContinentKeys.NorthAmerica || userContinentKey === Types_1.EContinentKeys.Canada)) {
                return amountInStock
                    ? {
                        message: `${amountInStock} ${t('/haldex/add_to_cart/stock_status/in_stock')} ${locationId === 'USA' ? 'US' : 'Canada'}`,
                        colorStatus: AddToCart_1.ColorStatus.Green
                    }
                    : userContinentKey === Types_1.EContinentKeys.Canada && locationId !== 'USA'
                        ? {
                            message: t('/haldex/add_to_cart/stock_status/can_customer_service'),
                            number: t('/haldex/add_to_cart/stock_status/can_number'),
                            colorStatus: AddToCart_1.ColorStatus.Yellow
                        }
                        : {
                            message: t('/haldex/add_to_cart/stock_status/usa_customer_service'),
                            number: t('/haldex/add_to_cart/stock_status/usa_number'),
                            colorStatus: AddToCart_1.ColorStatus.Yellow
                        };
            }
            else {
                return amountInStock
                    ? {
                        message: `${amountInStock} ${t('/haldex/add_to_cart/stock_status/in_stock')} ${locationId === 'USA' ? 'US' : 'Canada'}`,
                        colorStatus: AddToCart_1.ColorStatus.Green
                    }
                    : locationId === 'USA'
                        ? {
                            message: t('/haldex/add_to_cart/stock_status/usa_customer_service'),
                            number: t('/haldex/add_to_cart/stock_status/usa_number'),
                            colorStatus: AddToCart_1.ColorStatus.Yellow
                        }
                        : {
                            message: t('/haldex/add_to_cart/stock_status/can_customer_service'),
                            number: t('/haldex/add_to_cart/stock_status/can_number'),
                            colorStatus: AddToCart_1.ColorStatus.Yellow
                        };
            }
        }
    };
    const stockStatus = (0, react_1.useMemo)(() => {
        var _a;
        return stocks
            ? stocks.map(stock => {
                var _a;
                return getStockStatus(productionStatusCode, (_a = userData === null || userData === void 0 ? void 0 : userData.userProfile) === null || _a === void 0 ? void 0 : _a.haldexOrganization, stock.availableAmount, stock.locationId);
            })
            : [getStockStatus(productionStatusCode, (_a = userData === null || userData === void 0 ? void 0 : userData.userProfile) === null || _a === void 0 ? void 0 : _a.haldexOrganization)];
    }, [stocks, isReady, t]);
    return { stockStatus };
};
exports.useStockStatus = useStockStatus;
